import * as React from 'react';

import { Phrase } from 'components/shared';
import { PhraseType } from 'types/shared';

interface DepartureAndArrivalTimeProps {
  departureAndArrivalTime: PhraseType;
  differentDayArrival: string;
}

//TODO: remove spans and use utik-text. UDS-2112
export const DepartureAndArrivalTime = ({
  departureAndArrivalTime,
  differentDayArrival
}: DepartureAndArrivalTimeProps) => (
  <>
    <span className="uitk-type-heading-400 all-t-margin-one truncate" data-test-id="departure-time">
      <Phrase {...departureAndArrivalTime} />
    </span>
    {differentDayArrival && (
      <sup className="uitk-type-100 uitk-text-negative-theme all-l-margin-one" data-test-id="arrives-next-day">
        {differentDayArrival}
      </sup>
    )}
  </>
);
